import { capabilities, CapabilityGate } from '../Services';

const getIntegrationBlueprint = () => {
  let integrationBlueprint;
  if (CapabilityGate(capabilities.EMMA_DATA_INTEGRATION)) {
    integrationBlueprint = {
      groupHeader:   'Emma group(s)',
      groupHelpText:
        'Create Emma group(s) to receive contacts data from this experience. You can also select from existing group(s)',
      groupFieldType:         'multiselect',
      groupFieldName:         'emmaIntegrationGroupIds',
      groupValidationMessage:
        'There is already a group with this name. Please ensure you assign a new name to the group.',
      selectedGroupsLabel: 'Select a group(s)',
      createGroupLabel:    'Create a group',
      groupDescription:
        'The data integration will be defaulted to send the name and email to above group(s). You will be able to configure and add more data fields as you build your experience.',
      groupUrl:       'api/external/emma/groups',
      createGroupUrl: 'api/external/emma/addGroup',
    };
  }

  if (CapabilityGate(capabilities.CM_DATA_INTEGRATION)) {
    integrationBlueprint = {
      groupHeader:            'Select a list',
      groupHelpText:          'Select a list to store any new subscribers and the custom data you collect in this experience',
      groupFieldType:         'select',
      groupFieldName:         'cmIntegrationListId',
      groupValidationMessage:
        'There is already a list with this name. Please ensure you assign a new name to the list.',
      selectedGroupsLabel: 'Select a list',
      createGroupLabel:    'Create a list',
      groupDescription:
        'By default, we will store the name and email address of new subscribers. However, you can map any additional data you collect using the Integrations tab.',
      groupUrl:       'api/external/campaignMonitor/lists',
      createGroupUrl: 'api/external/campaignMonitor/addList',
    };
  }

  return integrationBlueprint;
};

export default getIntegrationBlueprint;
